import React, { useEffect, useState } from "react";
import IncomeCards from "../../Home/IncomeCards";
import green from "../../../Images/Vector 18.png";
import HomeService from "../../../Services/HomeService";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";
import { calculateDaysAgo } from "../../../utils/Helper";
import RowDataTableModal from "../../../Component/Modal/RowDataTableModal";

const Sales = () => {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");
  const [filterText, setFilterText] = useState("");
  const [filteredsubcriptions, setFilteredSubscriptions] = useState([]);

  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    city: "",
    locality: "",
  });
  const initialSalesProducts = [
    {
      name: "Subscription",
      totalSalesAmount: 0,
      totalSalesCount: 0,
    },
    {
      name: "Advertisement",
      totalSalesAmount: 0,
      totalSalesCount: 0,
    },
    {
      name: "Society",
      totalSalesAmount: 0,
      totalSalesCount: 0,
    },
    {
      name: "Community",
      totalSalesAmount: 0,
      totalSalesCount: 0,
    },
    {
      name: "Inventory",
      totalSalesAmount: 0,
      totalSalesCount: 0,
    },
  ];
  const [salesProducts, setSalesProducts] = useState(initialSalesProducts);

  const [cities, setCities] = useState([]);
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.status) {
        if (userCity) {
          setCities([res.data.find((item) => item._id === userCity)]);
          // fetchLocalities(userCity)
        } else {
          setCities(res.data);
        }
      } else {
        toast.error("Failed to fetch cities.");
      }
    } catch (error) {
      toast.error("Error fetching cities.");
      console.error("Error fetching cities:", error);
    }
  };
  const [localities, setLocalities] = useState([]);
  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      // console.log("HYT71", res);

      if (res?.data) {
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };
  const [loading, setLoading] = useState(false);
  const updateSalesProductCardInfo = (name, amountField, data) => {
    const total = data.reduce(
      (sum, item) => sum + (parseInt(item?.[amountField]) || 0),
      0
    );

    setSalesProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.name === name
          ? {
              ...product,
              totalSalesAmount: parseInt(total),
              totalSalesCount: data?.length || 0,
            }
          : product
      )
    );
  };

  //Subscriptions
  const [subscriptions, setSubscriptions] = useState([]);
  const [allSubscriptions, setAllSubscriptions] = useState([]);
  const fetchSubscriptions = async () => {
    try {
      const res = await HomeService.getSubscriptions();
      let fetchedData = [];

      console.log("IUY38", res.data);
      if (res?.status) {
        if (userCity) {
          fetchedData = res.data
            .filter((item) => item?.city[0]?._id === userCity)
            .sort((d1, d2) => new Date(d2.date) - new Date(d1.date));
        } else {
          fetchedData = res.data.sort(
            (d1, d2) => new Date(d2.date) - new Date(d1.date)
          );
        }

        updateSalesProductCardInfo("Subscription", "price", fetchedData);

        setAllSubscriptions(fetchedData || []);
        setSubscriptions(fetchedData || []);
      } else {
        toast.error("Failed to fetch subscriptions.");
      }
    } catch (error) {
      toast.error("Error fetching subscriptions.");
      console.error("Error fetching subscriptions:", error);
    } finally {
      setLoading(false);
    }
  };
  const [selectedLocalitiesList, setSelectedLocalitiesList] = useState([]);
  const [isLocalitiesModalOpen, setIsLocalitiesModalOpen] = useState(false);
  const handleLocalitiesView = (data) => {
    setSelectedLocalitiesList(data);
    setIsLocalitiesModalOpen(true);
  };
  const subscriptionColumns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.userDetails?.fullName || "N/A",
      // sortable: true,
    },
    {
      name: "Amount",
      cell: (row) => (
        <>
          <i
            class="fa fa-indian-rupee-sign"
            style={{
              marginRight: "3px",
            }}
          ></i>{" "}
          {row.price || 0}
        </>
      ),
      // sortable: true
    },
    {
      name: "Email",
      selector: (row) => row.userDetails?.email || "N/A",
      wrap: true,
    },
    {
      name: "City",
      selector: (row) => row.city[0]?.name,
      // sortable: true,
    },
    // {
    //   name: "Locality",
    //   selector: (row) => row.locality.map(item => item.name).join(", "),
    //   wrap: true,
    // },
    {
      name: "Localities",
      cell: (row) => (
        <>
          {row?.locality.length}&nbsp;
          <i
            className="fa-solid fa-eye "
            onClick={() => handleLocalitiesView(row?.locality)}
            style={{ cursor: "pointer", color: "darkBlue", fontSize: "12px" }}
          ></i>
        </>
      ),
      wrap: true,
      align: "center",
    },
    {
      name: "Start Date",
      selector: (row) =>
        moment(row.startDate.split("T")[0]).format("DD-MM-YYYY"),
      // sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => moment(row.endDate.split("T")[0]).format("DD-MM-YYYY"),
      // sortable: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      wrap: true,
    },
  ];
  const filterSubscriptions = () => {
    let filteredData = allSubscriptions;

    // console.log("FRT185",filteredData);

    if (filterData.startDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate >= new Date(filterData.startDate);
      });
    }

    if (filterData.endDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate <= new Date(filterData.endDate);
      });
    }

    if (filterData.city) {
      filteredData = filteredData.filter(
        (item) => item?.city[0]._id === filterData?.city
      );
    }

    if (filterData.locality) {
      console.log("FRT185", filteredData, filterData.locality);
      // filteredData = filteredData.filter((item) => item?.locality?._id === filterData?.locality)
      filteredData = filteredData.filter((item) =>
        item?.locality.some((loc) => loc._id === filterData.locality)
      );
    }

    console.log("HYT454", filterData, filteredData);
    updateSalesProductCardInfo("Subscription", "price", filteredData);
    setSubscriptions(filteredData || []);
  };

  //Advertisements
  const [advertisements, setAdvertisements] = useState([]);
  const [allAdvertisements, setAllAdvertisements] = useState([]);
  const fetchAdvertisements = async () => {
    try {
      const res = await HomeService.getAdvertisements();
      let fetchedData = [];

      console.log("ADV226", res.data);
      if (res?.status) {
        if (userCity) {
          fetchedData = res.data
            .filter((item) => item?.businessField[0]?._id === userCity)
            .sort((d1, d2) => new Date(d2.date) - new Date(d1.date));
        } else {
          fetchedData = res.data.sort(
            (d1, d2) => new Date(d2.date) - new Date(d1.date)
          );
        }

        updateSalesProductCardInfo("Advertisement", "amount", fetchedData);

        setAllAdvertisements(fetchedData || []);
        setAdvertisements(fetchedData || []);
      } else {
        toast.error("Failed to fetch Advertisements.");
      }
    } catch (error) {
      toast.error("Error fetching Advertisements.");
      console.error("Error fetching Advertisements:", error);
    } finally {
      setLoading(false);
    }
  };
  const advertisementColumns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.user?.fullName || "N/A",
      // sortable: true,
    },
    {
      name: "Amount",
      cell: (row) => (
        <>
          <i
            class="fa fa-indian-rupee-sign"
            style={{
              marginRight: "3px",
            }}
          ></i>{" "}
          {row.amount || 0}
        </>
      ),
      // sortable: true
    },
    {
      name: "Email",
      selector: (row) => row.user?.email || "N/A",
      wrap: true,
    },
    {
      name: "City",
      selector: (row) => row.businessField[0]?.name,
      // sortable: true,
    },
    // {
    //   name: "Locality",
    //   selector: (row) => row.locality.map(item => item.name).join(", "),
    //   wrap: true,
    // },
    {
      name: "Start Date",
      selector: (row) =>
        moment(row?.startDate?.split("T")[0]).format("DD-MM-YYYY"),
      // sortable: true,
    },
    {
      name: "End Date",
      selector: (row) =>
        moment(row?.endDate?.split("T")[0]).format("DD-MM-YYYY"),
      // sortable: true,
    },
    {
      name: "Remarks",
      selector: (row) => row?.remarks,
      wrap: true,
    },
  ];
  const filterAdvertisements = () => {
    let filteredData = allAdvertisements;
    if (filterData.startDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate >= new Date(filterData.startDate);
      });
    }

    if (filterData.endDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate <= new Date(filterData.endDate);
      });
    }

    if (filterData.city) {
      filteredData = filteredData.filter(
        (item) => item?.businessField[0]._id === filterData?.city
      );
    }

    // if (filterData.locality) {
    //   console.log("FRT185", filteredData, filterData.locality);
    //   filteredData = filteredData.filter(item =>
    //     item?.locality.some(loc => loc._id === filterData.locality)
    //   )
    // }

    console.log("HYT454", filterData, filteredData);
    updateSalesProductCardInfo("Advertisement", "amount", filteredData);
    setAdvertisements(filteredData || []);
  };

  //Society
  const [society, setSociety] = useState([]);
  const [allSociety, setAllSociety] = useState([]);
  const fetchSociety = async () => {
    try {
      const res = await HomeService.getSociety();
      let fetchedData = [];

      console.log("SOC343", res.data);
      if (res?.status) {
        if (userCity) {
          fetchedData = res.data
            .filter((item) => item?.city[0]?._id === userCity)
            .sort((d1, d2) => new Date(d2.date) - new Date(d1.date));
        } else {
          fetchedData = res.data.sort(
            (d1, d2) => new Date(d2.date) - new Date(d1.date)
          );
        }

        updateSalesProductCardInfo("Society", "price", fetchedData);

        setAllSociety(fetchedData || []);
        setSociety(fetchedData || []);
      } else {
        toast.error("Failed to fetch Society.");
      }
    } catch (error) {
      toast.error("Error fetching Society.");
      console.error("Error fetching Society:", error);
    } finally {
      setLoading(false);
    }
  };
  const societyColumns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.user?.fullName || "N/A",
      // sortable: true,
    },
    {
      name: "Amount",
      cell: (row) => (
        <>
          <i
            class="fa fa-indian-rupee-sign"
            style={{
              marginRight: "3px",
            }}
          ></i>{" "}
          {row.price || 0}
        </>
      ),
      // sortable: true
    },
    {
      name: "Email",
      selector: (row) => row.user?.email || "N/A",
      wrap: true,
    },
    {
      name: "City",
      selector: (row) => row.city[0]?.name,
      // sortable: true,
    },
    {
      name: "Locality",
      selector: (row) => row.locality.map((item) => item.name).join(", "),
      wrap: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      wrap: true,
    },
  ];
  const filterSociety = () => {
    let filteredData = allSociety;

    // console.log("FRT185",filteredData);

    if (filterData.startDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate >= new Date(filterData.startDate);
      });
    }

    if (filterData.endDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate <= new Date(filterData.endDate);
      });
    }

    if (filterData.city) {
      filteredData = filteredData.filter(
        (item) => item?.city[0]._id === filterData?.city
      );
    }

    if (filterData.locality) {
      console.log("FRT185", filteredData, filterData.locality);
      // filteredData = filteredData.filter((item) => item?.locality?._id === filterData?.locality)
      filteredData = filteredData.filter((item) =>
        item?.locality.some((loc) => loc._id === filterData.locality)
      );
    }

    console.log("HYT454", filterData, filteredData);
    updateSalesProductCardInfo("Society", "price", filteredData);
    setSociety(filteredData || []);
  };

  //Community
  const [community, setCommunity] = useState([]);
  const [allCommunity, setAllCommunity] = useState([]);
  const fetchCommunity = async () => {
    try {
      const res = await HomeService.getCommunity();
      let fetchedData = [];

      if (res?.status) {
        if (userCity) {
          fetchedData = res.data
            .filter((item) => item?.city[0]?._id === userCity)
            .sort((d1, d2) => new Date(d2.date) - new Date(d1.date));
        } else {
          fetchedData = res.data.sort(
            (d1, d2) => new Date(d2.date) - new Date(d1.date)
          );
        }

        console.log("COM456", res.data, fetchedData);

        updateSalesProductCardInfo("Community", "price", fetchedData);

        setAllCommunity(fetchedData || []);
        setCommunity(fetchedData || []);
      } else {
        toast.error("Failed to fetch Community.");
      }
    } catch (error) {
      toast.error("Error fetching Community.");
      console.error("Error fetching Community:", error);
    } finally {
      setLoading(false);
    }
  };
  const communityColumns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.userDetails?.fullName || "N/A",
      // sortable: true,
    },
    {
      name: "Amount",
      cell: (row) => (
        <>
          <i
            class="fa fa-indian-rupee-sign"
            style={{
              marginRight: "3px",
            }}
          ></i>{" "}
          {row.price || 0}
        </>
      ),
      // sortable: true
    },
    {
      name: "Email",
      selector: (row) => row.userDetails?.email || "N/A",
      wrap: true,
    },
    {
      name: "City",
      selector: (row) => row.city[0]?.name,
      // sortable: true,
    },
    {
      name: "Locality",
      selector: (row) => row.locality.map((item) => item.name).join(", "),
      wrap: true,
    },
    {
      name: "Start Date",
      selector: (row) =>
        moment(row.startDate.split("T")[0]).format("DD-MM-YYYY"),
      // sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => moment(row.endDate.split("T")[0]).format("DD-MM-YYYY"),
      // sortable: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      wrap: true,
    },
  ];
  const filterCommunity = () => {
    let filteredData = allCommunity;

    // console.log("FRT185",filteredData);

    if (filterData.startDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate >= new Date(filterData.startDate);
      });
    }

    if (filterData.endDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate <= new Date(filterData.endDate);
      });
    }

    if (filterData.city) {
      filteredData = filteredData.filter(
        (item) => item?.city[0]._id === filterData?.city
      );
    }

    if (filterData.locality) {
      console.log("FRT185", filteredData, filterData.locality);
      // filteredData = filteredData.filter((item) => item?.locality?._id === filterData?.locality)
      filteredData = filteredData.filter((item) =>
        item?.locality.some((loc) => loc._id === filterData.locality)
      );
    }

    console.log("HYT454", filterData, filteredData);
    updateSalesProductCardInfo("Community", "price", filteredData);
    setCommunity(filteredData || []);
  };

  //Inventory
  const [inventory, setInventory] = useState([]);
  const [allInventory, setAllInventory] = useState([]);
  const fetchInventory = async () => {
    try {
      const res = await HomeService.getInventory();
      let fetchedData = [];

      console.log("INV579", res.data);
      if (res?.status) {
        if (userCity) {
          fetchedData = res.data
            .filter((item) => item?.city[0]?._id === userCity)
            .sort((d1, d2) => new Date(d2.date) - new Date(d1.date));
        } else {
          fetchedData = res.data.sort(
            (d1, d2) => new Date(d2.date) - new Date(d1.date)
          );
        }
        updateSalesProductCardInfo("Inventory", "price", fetchedData);
        setAllInventory(fetchedData || []);
        setInventory(fetchedData || []);
      } else {
        toast.error("Failed to fetch Inventory.");
      }
    } catch (error) {
      toast.error("Error fetching Inventory.");
      console.error("Error fetching Inventory:", error);
    } finally {
      setLoading(false);
    }
  };
  const inventoryColumns = [
    {
      name: "Date",
      selector: (row) => moment(row?.date?.split("T")[0]).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.userDetails?.fullName || "N/A",
      // sortable: true,
    },
    {
      name: "Amount",
      cell: (row) => (
        <>
          <i
            class="fa fa-indian-rupee-sign"
            style={{
              marginRight: "3px",
            }}
          ></i>{" "}
          {row.price || 0}
        </>
      ),
      // sortable: true
    },
    {
      name: "Email",
      selector: (row) => row.userDetails?.email || "N/A",
      wrap: true,
    },
    {
      name: "City",
      selector: (row) => row.city[0]?.name,
      // sortable: true,
    },
    {
      name: "Locality",
      selector: (row) => row.locality.map((item) => item.name).join(", "),
      wrap: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      wrap: true,
    },
  ];
  const filterInventory = () => {
    let filteredData = allInventory;

    // console.log("FRT185",filteredData);

    if (filterData.startDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate >= new Date(filterData.startDate);
      });
    }

    if (filterData.endDate) {
      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        return itemDate <= new Date(filterData.endDate);
      });
    }

    if (filterData.city) {
      filteredData = filteredData.filter(
        (item) => item?.city[0]._id === filterData?.city
      );
    }

    if (filterData.locality) {
      console.log("FRT185", filteredData, filterData.locality);
      // filteredData = filteredData.filter((item) => item?.locality?._id === filterData?.locality)
      filteredData = filteredData.filter((item) =>
        item?.locality.some((loc) => loc._id === filterData.locality)
      );
    }

    console.log("HYT454", filterData, filteredData);
    updateSalesProductCardInfo("Inventory", "price", filteredData);
    setInventory(filteredData || []);
  };

  // Function to export data to Excel
  const exportToExcel = (rawData, dataCategory) => {
    //locality,address(a name),area,flor,bhk,owner name,owner number,remark,facing,age,price/rent,time
    // return
    console.log("HDF694", rawData);
    // return

    function formatToDDMMYYYY(input, { useUTC = true, sep = "-" } = {}) {
      if (input === null || input === undefined) return null;

      let date;
      if (input instanceof Date) {
        date = input;
      } else if (typeof input === "number" && isFinite(input)) {
        date = new Date(input);
      } else if (typeof input === "string") {
        // try parsing ISO or other date strings
        const parsed = Date.parse(input);
        if (isNaN(parsed)) return null;
        date = new Date(parsed);
      } else {
        return null;
      }

      // check valid date
      if (isNaN(date.getTime())) return null;

      // choose getters depending on UTC flag
      const day = useUTC ? date.getUTCDate() : date.getDate();
      const month = useUTC ? date.getUTCMonth() + 1 : date.getMonth() + 1; // months 0-11
      const year = useUTC ? date.getUTCFullYear() : date.getFullYear();

      // zero-pad
      const dd = String(day).padStart(2, "0");
      const mm = String(month).padStart(2, "0");
      const yyyy = String(year);

      return `${dd}${sep}${mm}${sep}${yyyy}`;
    }

    const exportableData = rawData?.map((item, index) => ({
      Sl: index + 1,
      City: item?.city.length
        ? item?.city[0].name
        : item?.businessField[0].name,
      Locality: item?.locality
        ? item?.locality.map((item) => item.name).join(", ")
        : item?.majorLocality,
      Price_Rent: item?.price,
      Remarks: item?.remarks,
      Owner: item?.userDetails
        ? item?.userDetails.fullName
        : item?.user.fullName,
      Phone: item?.userDetails
        ? item?.userDetails.mobileNo
        : item?.user.mobileNo,
      Email: item?.userDetails ? item?.userDetails.email : item?.user.email,
      Date: formatToDDMMYYYY(item?.date),
      Start_Date: formatToDDMMYYYY(item?.createdOn),
      End_Date: formatToDDMMYYYY(item?.endDate),
    }));

    console.log("EXP531", exportableData);

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = `SALES_${dataCategory.toUpperCase()}_${moment().format(
      "DDMMYYYYhhmmss"
    )}`;

    const ws = XLSX.utils.json_to_sheet(exportableData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    saveAs(data, fileName + fileExtension);
  };

  useEffect(() => {
    fetchCities();
    fetchSubscriptions();
    fetchAdvertisements();
    fetchSociety();
    fetchCommunity();
    fetchInventory();
  }, []);

  const filter = () => {
    console.log("subcriptions", subscriptions);
    const text = filterText.toLowerCase();

    const filteredData = subscriptions.filter((item) => {
      const nameMatch = item?.userDetails?.fullName
        ?.toLowerCase()
        .includes(text);
      const emailMatch = item?.userDetails?.email?.toLowerCase().includes(text);
      return nameMatch || emailMatch;
    });

    console.log("filteredData", filteredData);
    setFilteredSubscriptions([...filteredData]);
  };

  useEffect(() => {
    filter();
  }, [filterText]);

  return (
    <>
      <div
        className="main_wrap"
        style={{
          padding: "0px 20px 50px 20px",
        }}
      >
        <div
          style={{
            padding: "20px 0px",
          }}
        >
          <h2 className="dashboard_head">Sales</h2>
          <h4 className="dahsboard_head_para">
            An any way to manage sales with care and passion
          </h4>
        </div>
        <div className="dash_board_wrapper">
          <div
            className="card_wrapper_home"
            style={{
              width: "100%",
              flexWrap: "wrap",
              rowGap: "20px",
            }}
          >
            {salesProducts.map((e, i) => {
              return (
                <div className="card_div card_width">
                  <div className="net_income_head_wrapper">
                    <h5>{e?.name}</h5>
                    {/* <i class="fa-solid fa-ellipsis"></i> */}
                  </div>
                  <h1 className="income_number">
                    <span>
                      <i className="fa fa-indian-rupee-sign"></i>
                    </span>
                    {e?.totalSalesAmount}
                  </h1>
                  <p className="profit_para">
                    <img src={green} />
                    <p>Total count </p>
                    <span>{e?.totalSalesCount}</span>
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <nav>
          <div class="nav nav-tabs mt-4" id="nav-tab" role="tablist">
            <button
              class="nav-link active"
              id="nav-subscription-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-subscription"
              type="button"
              role="tab"
              aria-controls="nav-subscription"
              aria-selected="true"
            >
              Subscription
            </button>
            <button
              class="nav-link"
              id="nav-advertisment-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-advertisment"
              type="button"
              role="tab"
              aria-controls="nav-advertisment"
              aria-selected="false"
            >
              Advertisement
            </button>
            <button
              class="nav-link"
              id="nav-society-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-society"
              type="button"
              role="tab"
              aria-controls="nav-society"
              aria-selected="false"
            >
              Society
            </button>
            <button
              class="nav-link"
              id="nav-community-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-community"
              type="button"
              role="tab"
              aria-controls="nav-community"
              aria-selected="false"
            >
              Community
            </button>
            <button
              class="nav-link"
              id="nav-inventory-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-inventory"
              type="button"
              role="tab"
              aria-controls="nav-inventory"
              aria-selected="false"
            >
              Inventory
            </button>
          </div>
        </nav>
        <div class="tab-content mt-2" id="nav-tabContent">
          <div
            class="tab-pane fade show active"
            id="nav-subscription"
            role="tabpanel"
            aria-labelledby="nav-subscription-tab"
          >
            <section name="Subscriptions" className="_chartBox_area">
              <div className="row mb-2">
                <div className="col-md-2 mt-3">
                  <label htmlFor="startDate">Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    className="form-control"
                    value={filterData.startDate}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        startDate: e.target.value,
                      })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label htmlFor="endDate">End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    className="form-control"
                    value={filterData.endDate}
                    onChange={(e) =>
                      setFilterData({ ...filterData, endDate: e.target.value })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label>City</label>
                  <select
                    className="form-control"
                    name="city"
                    value={filterData.city}
                    onChange={(e) => {
                      setFilterData({ ...filterData, city: e.target.value });
                      fetchLocalities(e.target.value);
                    }}
                    // required
                  >
                    <option value="">---Select City---</option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2 mt-3">
                  <label>Locality</label>
                  <select
                    className="form-control"
                    value={filterData.locality}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        locality: e.target.value,
                      })
                    }
                  >
                    <option value="">---Select---</option>
                    {localities.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="col-md-2 mt-3">
                  <label>Filter</label>
                  <input
                    value={filterText}
                    onChange={(e) => {
                      setFilterText(e?.target?.value);
                    }}
                    placeholder="name or email ID"
                    type="text"
                    style={{
                      height: "35px",
                      borderRadius: "5px",
                      padding: "0 5px",
                      border: "1px solid grey",
                      // width: "30%",
                    }}
                  />
                </div> */}
                <div
                  className="col-md-4 mt-3"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    // marginTop: "25px",
                    alignItems: "center",
                  }}
                >
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      filterSubscriptions();
                      filterAdvertisements();
                      filterSociety();
                      filterCommunity();
                      filterInventory();
                    }}
                  >
                    Filter
                  </button>
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      fetchSubscriptions();
                      fetchAdvertisements();
                      fetchSociety();
                      fetchCommunity();
                      fetchInventory();
                      setFilterData({
                        startDate: "",
                        endDate: "",
                        city: "",
                      });
                    }}
                  >
                    Clear
                  </button>

                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    className="btn mt-3 ml-2"
                    onClick={(e) =>
                      exportToExcel(
                        filterText ? filteredsubcriptions : subscriptions,
                        "subscriptions"
                      )
                    }
                  >
                    Export (
                    {filterText
                      ? filteredsubcriptions.length
                      : subscriptions.length || 0}
                    )
                  </button>
                </div>
                <div className="col-md-2 mt-3">
                  <label>Filter</label>
                  <input
                    value={filterText}
                    onChange={(e) => {
                      setFilterText(e?.target?.value);
                    }}
                    placeholder="name or email ID"
                    type="text"
                    style={{
                      height: "35px",
                      borderRadius: "5px",
                      padding: "0 5px",
                      border: "1px solid grey",
                      // width: "30%",
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <DataTable
                    columns={subscriptionColumns}
                    // data={subscriptions}
                    data={filterText ? filteredsubcriptions : subscriptions}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                  <RowDataTableModal
                    isOpen={isLocalitiesModalOpen}
                    closeModal={() => setIsLocalitiesModalOpen(false)}
                    data={selectedLocalitiesList}
                    title="Localities"
                    type="localities"
                  />
                </div>
              </div>
            </section>
          </div>
          <div
            class="tab-pane fade"
            id="nav-advertisment"
            role="tabpanel"
            aria-labelledby="nav-advertisment-tab"
          >
            <section name="Advertisement" className="_chartBox_area">
              <div className="row mb-2">
                <div className="col-md-2 mt-3">
                  <label htmlFor="startDate">Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    className="form-control"
                    value={filterData.startDate}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        startDate: e.target.value,
                      })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label htmlFor="endDate">End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    className="form-control"
                    value={filterData.endDate}
                    onChange={(e) =>
                      setFilterData({ ...filterData, endDate: e.target.value })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label>City</label>
                  <select
                    className="form-control"
                    name="city"
                    value={filterData.city}
                    onChange={(e) => {
                      setFilterData({ ...filterData, city: e.target.value });
                      fetchLocalities(e.target.value);
                    }}
                    // required
                  >
                    <option value="">---Select City---</option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2 mt-3">
                  <label>Locality</label>
                  <select
                    className="form-control"
                    value={filterData.locality}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        locality: e.target.value,
                      })
                    }
                  >
                    <option value="">---Select---</option>
                    {localities.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className="col-md-4 mt-3"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      filterSubscriptions();
                      filterAdvertisements();
                      filterSociety();
                      filterCommunity();
                      filterInventory();
                    }}
                  >
                    Filter
                  </button>
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      fetchSubscriptions();
                      fetchAdvertisements();
                      fetchSociety();
                      fetchCommunity();
                      fetchInventory();
                      setFilterData({
                        startDate: "",
                        endDate: "",
                        city: "",
                      });
                    }}
                  >
                    Clear
                  </button>

                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    className="btn mt-3 ml-2"
                    onClick={(e) =>
                      exportToExcel(advertisements, "advertisements")
                    }
                  >
                    Export ({advertisements.length || 0})
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <DataTable
                    columns={advertisementColumns}
                    data={advertisements}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                </div>
              </div>
            </section>
          </div>
          <div
            class="tab-pane fade"
            id="nav-society"
            role="tabpanel"
            aria-labelledby="nav-society-tab"
          >
            <section name="Society" className="_chartBox_area">
              <div className="row mb-2">
                <div className="col-md-2 mt-3">
                  <label htmlFor="startDate">Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    className="form-control"
                    value={filterData.startDate}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        startDate: e.target.value,
                      })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label htmlFor="endDate">End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    className="form-control"
                    value={filterData.endDate}
                    onChange={(e) =>
                      setFilterData({ ...filterData, endDate: e.target.value })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label>City</label>
                  <select
                    className="form-control"
                    name="city"
                    value={filterData.city}
                    onChange={(e) => {
                      setFilterData({ ...filterData, city: e.target.value });
                      fetchLocalities(e.target.value);
                    }}
                    // required
                  >
                    <option value="">---Select City---</option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2 mt-3">
                  <label>Locality</label>
                  <select
                    className="form-control"
                    value={filterData.locality}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        locality: e.target.value,
                      })
                    }
                  >
                    <option value="">---Select---</option>
                    {localities.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className="col-md-4 mt-3"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      filterSubscriptions();
                      filterAdvertisements();
                      filterSociety();
                      filterCommunity();
                      filterInventory();
                    }}
                  >
                    Filter
                  </button>
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      fetchSubscriptions();
                      fetchAdvertisements();
                      fetchSociety();
                      fetchCommunity();
                      fetchInventory();
                      setFilterData({
                        startDate: "",
                        endDate: "",
                        city: "",
                      });
                    }}
                  >
                    Clear
                  </button>

                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    className="btn mt-3 ml-2"
                    onClick={(e) => exportToExcel(society, "society")}
                  >
                    Export ({society.length || 0})
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <DataTable
                    columns={societyColumns}
                    data={society}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                </div>
              </div>
            </section>
          </div>
          <div
            class="tab-pane fade"
            id="nav-community"
            role="tabpanel"
            aria-labelledby="nav-community-tab"
          >
            <section name="Community" className="_chartBox_area">
              <div className="row mb-2">
                <div className="col-md-2 mt-3">
                  <label htmlFor="startDate">Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    className="form-control"
                    value={filterData.startDate}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        startDate: e.target.value,
                      })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label htmlFor="endDate">End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    className="form-control"
                    value={filterData.endDate}
                    onChange={(e) =>
                      setFilterData({ ...filterData, endDate: e.target.value })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label>City</label>
                  <select
                    className="form-control"
                    name="city"
                    value={filterData.city}
                    onChange={(e) => {
                      setFilterData({ ...filterData, city: e.target.value });
                      fetchLocalities(e.target.value);
                    }}
                    // required
                  >
                    <option value="">---Select City---</option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2 mt-3">
                  <label>Locality</label>
                  <select
                    className="form-control"
                    value={filterData.locality}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        locality: e.target.value,
                      })
                    }
                  >
                    <option value="">---Select---</option>
                    {localities.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className="col-md-4 mt-3"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      filterSubscriptions();
                      filterAdvertisements();
                      filterSociety();
                      filterCommunity();
                      filterInventory();
                    }}
                  >
                    Filter
                  </button>
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      fetchSubscriptions();
                      fetchAdvertisements();
                      fetchSociety();
                      fetchCommunity();
                      fetchInventory();
                      setFilterData({
                        startDate: "",
                        endDate: "",
                        city: "",
                      });
                    }}
                  >
                    Clear
                  </button>
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    className="btn mt-3 ml-2"
                    onClick={(e) => exportToExcel(community, "community")}
                  >
                    Export ({community.length || 0})
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <DataTable
                    columns={communityColumns}
                    data={community}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                </div>
              </div>
            </section>
          </div>
          <div
            class="tab-pane fade"
            id="nav-inventory"
            role="tabpanel"
            aria-labelledby="nav-inventory-tab"
          >
            <section name="Inventory" className="_chartBox_area">
              <div className="row mb-2">
                <div className="col-md-2 mt-3">
                  <label htmlFor="startDate">Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    className="form-control"
                    value={filterData.startDate}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        startDate: e.target.value,
                      })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label htmlFor="endDate">End Date</label>
                  <input
                    type="date"
                    name="endDate"
                    className="form-control"
                    value={filterData.endDate}
                    onChange={(e) =>
                      setFilterData({ ...filterData, endDate: e.target.value })
                    }
                    // required
                  />
                </div>
                <div className="col-md-2 mt-3">
                  <label>City</label>
                  <select
                    className="form-control"
                    name="city"
                    value={filterData.city}
                    onChange={(e) => {
                      setFilterData({ ...filterData, city: e.target.value });
                      fetchLocalities(e.target.value);
                    }}
                    // required
                  >
                    <option value="">---Select City---</option>
                    {cities.map((city, key) => (
                      <option key={key} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2 mt-3">
                  <label>Locality</label>
                  <select
                    className="form-control"
                    value={filterData.locality}
                    onChange={(e) =>
                      setFilterData({
                        ...filterData,
                        locality: e.target.value,
                      })
                    }
                  >
                    <option value="">---Select---</option>
                    {localities.map((item, key) => (
                      <option key={key} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className="col-md-4 mt-3"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      filterSubscriptions();
                      filterAdvertisements();
                      filterSociety();
                      filterCommunity();
                      filterInventory();
                    }}
                  >
                    Filter
                  </button>
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    type="submit"
                    className="btn mt-3"
                    onClick={(e) => {
                      fetchSubscriptions();
                      fetchAdvertisements();
                      fetchSociety();
                      fetchCommunity();
                      fetchInventory();
                      setFilterData({
                        startDate: "",
                        endDate: "",
                        city: "",
                      });
                    }}
                  >
                    Clear
                  </button>
                  <button
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      width: "fit-content",
                      height: "fit-content",
                    }}
                    className="btn mt-3 ml-2"
                    onClick={(e) => exportToExcel(inventory, "inventory")}
                  >
                    Export ({inventory.length || 0})
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <DataTable
                    columns={inventoryColumns}
                    data={inventory}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sales;
